"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _Channel = _interopRequireDefault(require("./components/Channel"));
var _ChannelList = _interopRequireDefault(require("./components/ChannelList"));
var _ChannelHeader = _interopRequireDefault(require("./components/ChannelHeader"));
var _utils = require("./utils");
var _utils2 = require("../../utils");
require("./GroupChats.less");
require("./components/CustomAvatar.less");
var _excluded = ["chatClient"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Chats = function Chats(_ref) {
  var _staticChannelItems$f;
  var _ref$ChannelList = _ref.ChannelList,
    ChannelList = _ref$ChannelList === void 0 ? _ChannelList.default : _ref$ChannelList,
    _ref$ChannelHeader = _ref.ChannelHeader,
    ChannelHeader = _ref$ChannelHeader === void 0 ? _ChannelHeader.default : _ref$ChannelHeader,
    chatClient = _ref.chatClient,
    activeChannelId = _ref.activeChannelId,
    filters = _ref.filters,
    channelRenderFilterFn = _ref.channelRenderFilterFn,
    globalBan = _ref.globalBan,
    _ref$baseUrl = _ref.baseUrl,
    baseUrl = _ref$baseUrl === void 0 ? _utils2.DEFAULT_COMMUNITY_CHAT_URL : _ref$baseUrl,
    showStaticChannels = _ref.showStaticChannels,
    _ref$appMenuCollapsed = _ref.appMenuCollapsed,
    appMenuCollapsed = _ref$appMenuCollapsed === void 0 ? false : _ref$appMenuCollapsed;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    rerenderCount = _useState4[0],
    setRerenderCount = _useState4[1];

  // this is a hack to make Chat rerender when channel membership changed
  var forceRerender = (0, _react.useCallback)(function () {
    setRerenderCount(function (count) {
      return count + 1;
    });
  }, [rerenderCount]);
  var _useOnChannelLeave = (0, _utils.useOnChannelLeave)({
      onSuccess: forceRerender
    }),
    leaveChat = _useOnChannelLeave.leaveChat,
    leavingChat = _useOnChannelLeave.loading,
    onRemovedFromChannel = _useOnChannelLeave.onRemovedFromChannel;
  var _useOnChannelJoin = (0, _utils.useOnChannelJoin)({
      onSuccess: forceRerender
    }),
    joinChat = _useOnChannelJoin.joinChat,
    joiningChat = _useOnChannelJoin.loading;
  var _useCommunityChannels = (0, _utils.useCommunityChannelsHistory)(setMenuOpen, baseUrl, chatClient),
    handleMobileChannelClose = _useCommunityChannels.handleMobileChannelClose;
  var _useStaticChannels = (0, _utils.useStaticChannels)(baseUrl, setMenuOpen),
    staticChannelId = _useStaticChannels.staticChannelId;

  // If corresponding static layout exists, we use it and staticChannelId to display the static channel
  var StaticChannelLayout = (_staticChannelItems$f = _utils.staticChannelItems.find(function (item) {
    return item.id === staticChannelId;
  })) === null || _staticChannelItems$f === void 0 ? void 0 : _staticChannelItems$f.component;

  // For mobile, where the channel list is separated from channel contents
  // itself in UI we also need to change the route back to initial one
  var onBackToChannelList = function onBackToChannelList() {
    handleMobileChannelClose();
  };
  if (!chatClient) {
    return null;
  }
  var showStaticChannelHeader = (0, _utils2.isMobileOrTablet)() && !menuOpen && staticChannelId;
  return /*#__PURE__*/_react.default.createElement(_utils.CustomChatContextProvider, {
    baseUrl: baseUrl,
    setMenuOpen: setMenuOpen,
    staticChannelId: staticChannelId,
    showStaticChannels: showStaticChannels,
    appMenuCollapsed: appMenuCollapsed
  }, /*#__PURE__*/_react.default.createElement(ChannelList, {
    menuOpen: menuOpen,
    setMenuOpen: setMenuOpen,
    activeChannelId: activeChannelId,
    filters: filters,
    channelRenderFilterFn: channelRenderFilterFn,
    leaveChat: leaveChat,
    leavingChat: leavingChat,
    onRemovedFromChannel: onRemovedFromChannel
  }), StaticChannelLayout ? /*#__PURE__*/_react.default.createElement(StaticChannelLayout, {
    ChannelHeader: showStaticChannelHeader ? /*#__PURE__*/_react.default.createElement(ChannelHeader, {
      staticChannelId: staticChannelId,
      onBack: onBackToChannelList
    }) : null
  }) : /*#__PURE__*/_react.default.createElement(_Channel.default, {
    client: chatClient,
    ChannelHeader: menuOpen && (0, _utils2.isMobileOrTablet)() ? null : ChannelHeader,
    onBack: onBackToChannelList,
    joinChat: joinChat,
    joiningChat: joiningChat,
    globalBan: globalBan
  }));
};
var GroupChats = function GroupChats(_ref2) {
  var chatClient = _ref2.chatClient,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "GroupChats"
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.Chat, {
    client: chatClient,
    theme: "team light"
  }, /*#__PURE__*/_react.default.createElement(Chats, _extends({
    chatClient: chatClient
  }, props))));
};
var _default = GroupChats;
exports.default = _default;